<template>
  <EditorPopover ref="popover" @cancel="cancelEditing">

    <TabbedBox>
      <template v-slot:tablist>
        <Tab :first="true" tabid="tab-datum">
          <i class="far fa-ruler-vertical"></i> Datum Line
        </Tab>
      </template>

      <template v-slot:tabcontent>
        <TabPage :first="true" tabid="tab-datum">
          Datum Length: {{formatDecimal(datumLength, 2)}}mm

          <div class="row mt-2" v-if="false && editingEnabled">
            <div class="col-6">
              <div class="row">
                <label class="col-form-label col-6 font-weight-bold">Show Dimension</label>
                <div class="col-6">
                  <FormSwitch booleanMode v-model="isDimensionDisplayed" />
                </div>
              </div>
            </div>
          </div>

          <EditorPopoverButtonList v-if="editingEnabled">
            <!-- <EditorPopoverButton title="Cancel" type="cancel" icon="fa-times" @click="cancelEditing" /> -->
            <EditorPopoverButton title="Remove Line" type="remove" icon="fa-trash-alt" @click="popoverActionButtonClick('remove')" />
            <!-- <EditorPopoverButton title="Apply" type="update" icon="fa-check" @click="applyDatumEdit" /> -->
          </EditorPopoverButtonList>
        </TabPage>
      </template>
    </TabbedBox>  
    
  </EditorPopover>
</template>



<script>
import _ from 'lodash'
import Utils from '@/utils/utils'
import EditorPopover from '@glass-designer/components/editorPopover'
import EditorPopoverMixin from '@glass-designer/mixins/editorPopover'
import EditorPopoverDataRow from '@glass-designer/components/editorPopoverDataRow'
import EditorKeypad from '@glass-designer/components/editorKeypad'
import MathsUtils from '@/utils/mathsUtils'

import EditorPopoverButtonList from '@glass-designer/components/popover/editorPopoverButtonList'
import EditorPopoverButton from '@glass-designer/components/popover/editorPopoverButton'

import { LibraryItemShapeTypes } from '@glass-designer/types'

export default {
  name: 'EditorDatumPopover',
  mixins: [EditorPopoverMixin],
  components: {
    EditorPopover,
    EditorPopoverDataRow,
    EditorPopoverButtonList,
    EditorPopoverButton
  },
  props: {
    editingEnabled: {
      type: Boolean,
      default: true
    },
  },
  data() {
    return {
      toolInfoText: '',
      name: '',
      datumLength: 0,
      isDimensionDisplayed: false
    }
  },
  computed: {
  },
  watch: {
    
  },
  created() {

  },
  methods: {
    setup(editor, options) {
      this.clearOptions()

      this.name = options.name || 'Datum Line'
      let datumData = options.datumData || {}
      this.datumLength = datumData.length || 0
      this.isDimensionDisplayed = !!datumData.isDimensionDisplayed

      // Setup callbacks next tick so they don't get called when resetting values
      this.callbackContext = options.context
      this.updateCallback = options.updateCallback
      this.actionCallback = options.actionCallback
      this.applyCallback = options.applyCallback
      this.cancelCallback = options.cancelCallback
    },
    clearOptions() {
      this.itemData = null

      this.callbackContext = null
      this.updateCallback = null
      this.actionCallback = null
      this.applyCallback = null
      this.cancelCallback = null
    },
    displayToolPopover(containerEl, editor, displayOptions) {
      this.$refs.popover.displayToolPopover(containerEl, editor, displayOptions)
    },
    viewportUpdated(containerEl, editor) {
    },
    hide() {
      if(this.cancelCallback) {
        // Reset cancel CB so it only is called once when hiding popovers
        let cancelCB = this.cancelCallback
        this.cancelCallback = null

        cancelCB(this.callbackContext, false)
      }

      this.clearOptions()
      this.$refs.popover.hide()
    },
    cancelEditing() {
      if(this.cancelCallback)
        this.cancelCallback(this.callbackContext, true)

      this.clearOptions()
      this.hide()
    },
    onShortcutKey(code) {
      switch(code) {
        case 'Escape':
          this.cancelEditing()
          break
      }
    },
    applyDatumEdit() {
      // TODO: This
    }
  }
}
</script>